export default "__VITE_ASSET__DJ3jG1KL__"